import { createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme) =>
  createStyles({
    input: {
      height: theme.spacing(6),
      maxWidth: 550,
      marginBottom: theme.spacing(2),
      border: `1px solid ${theme.palette.divider}`,
      background: `${theme.palette.background.paper} !important`,
      caretColor: theme.palette.primary.main,
      '& input': {
        '&::placeholder': {
          fontFamily: theme.typography.fontFamily,
          letterSpacing: 0.5,
          fontSize: 16,
        },
      },
    },
  })
);
